import { useState, useEffect } from 'react';
import { useAppSelector } from '@/redux';
import PropTypes from 'prop-types';

import { useServices } from '@/services/useServices';
import ESpot from './ESpot';

export const ESpotsLoader = ({ storeId, locations, locale }) => {
  const { espotService } = useServices();
  const [components, setComponents] = useState<React.JSX.Element[]>([]);
  const isMobileDevice = useAppSelector(({ gui }) => gui.isMobileDevice);

  useEffect(() => {
    const subscription = espotService.getEspotDataByLocations(storeId, locations).subscribe((spots) => {
      if (spots) {
        setComponents(spots.filter((spot) =>
          !!spot && (!isMobileDevice || (isMobileDevice && spot.isDisplayMobile))
        ).map((spot) => (
          <ESpot key={spot._id} spot={spot} locale={locale} />
        )));
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [storeId, locations, locale]);

  return <>{components}</>;
};

ESpotsLoader.propTypes = {
  storeId: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired,
  locale: PropTypes.string
};

export default ESpotsLoader;
